export const falseReturnFunc = () => false;
